// miniapp/src/client/guest/PaySuccess.tsx
import { useEffect } from "react";

export default function PaySuccess() {
  useEffect(() => {
    const tg = (window as any)?.Telegram?.WebApp;

    // небольшая задержка, чтобы Telegram инициализировался
    const t = setTimeout(() => {
      try {
        // прячем кнопки, на всякий
        tg?.BackButton?.hide?.();
        tg?.MainButton?.hide?.();
        // пробуем закрыть
        tg?.close?.();
      } catch (_e) {}

      // фолбэк: закроем вкладку/вернём на главную, если вне TWA
      try { window.close(); } catch {}
      // ещё один фолбэк — чтобы пользователь не завис на пустом экране
      window.location.replace("/");
    }, 150);

    return () => clearTimeout(t);
  }, []);

  // на экране можно ничего не рисовать, но лучше короткий текст на случай фолбэка
  return (
    <div className="p-4 text-center text-white/80 text-sm">
      Завершаем оплату… окно сейчас закроется.
    </div>
  );
}